import EventActionProto from '../event-action-proto'

export default class SessionRequestFormDelete extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            requestForm : sessionEvent.data,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false

        if (gd.session.requestFormsLoaded)
            gd.session.requestForms.remove(this.data.id)

        gd.modelBus.newUpdate('request-form', this.method, this.header.requestForm.id, this.data, this.header)
    }
}
